import { useState } from 'react';

const faqs = [
  {
    q: 'How long does it take to make a custom suit?',
    a: 'A fully bespoke custom suit typically takes 4 to 6 weeks from your initial consultation to final delivery. This includes fabric selection, precise measurements, construction, and one or more fittings. Rush services may be available — call us to discuss your timeline.',
  },
  {
    q: 'How much does a custom suit cost at British Custom Tailors?',
    a: 'Our custom suits start at competitive rates depending on fabric choice and construction type. We offer a range of premium fabrics from fine wool and cashmere blends to exotic materials. Contact us for a personalized quote — we believe exceptional quality is more accessible than most expect.',
  },
  {
    q: 'Do you offer same-day or next-day alterations?',
    a: 'Yes, we offer expedited alteration services depending on the scope of work. Simple adjustments such as hem shortening or waist suppression can often be completed within 24 to 48 hours. Contact us directly for urgent requests.',
  },
  {
    q: 'Do you travel to my home or office for fittings?',
    a: 'Absolutely. Our house call and office call service is available nationwide. One of our expert consultants will travel to your location with fabric swatches, measuring tools, and style guides — giving you the full studio experience at your convenience.',
  },
  {
    q: 'What is the process for getting a custom suit made?',
    a: 'We begin with an in-person or house call consultation where we take your measurements, discuss your style preferences, and select your fabrics. We then craft your garment using traditional tailoring techniques, followed by one or more fittings to ensure a perfect fit before delivery.',
  },
  {
    q: 'Do you make custom suits for women as well as men?',
    a: 'Yes, British Custom Tailors crafts bespoke garments for both men and women — including suits, blazers, trousers, and formal wear. Our tailors are equally skilled in women\'s tailoring and will guide you through every style option.',
  },
  {
    q: 'What types of fabric do you offer for custom garments?',
    a: 'We carry over 500 fabrics from the world\'s leading mills including Loro Piana, Holland and Sherry, Scabal, and Dormeuil. Options include merino wool, cashmere, linen, cotton, and luxury blends across a vast range of colors, patterns, and weights.',
  },
  {
    q: 'Can you alter a suit or garment I already own?',
    a: 'Yes. Our expert alterations service handles everything from basic adjustments to complete reconstructions. We work on suits, blazers, trousers, dresses, and shirts — regardless of brand or original tailor.',
  },
  {
    q: 'Do you offer wedding and formal wear tailoring?',
    a: 'Yes, we specialize in wedding and formal wear including groom\'s suits, morning suits, tuxedos, and formalwear for the entire wedding party. We recommend booking at least 8 to 12 weeks before your event for full bespoke service.',
  },
  {
    q: 'How do I get started with British Custom Tailors?',
    a: 'Simply call us at 866-857-8487 to schedule your first consultation — in our Wellesley Hills studio or at your location via our nationwide house call service. We\'ll walk you through every step of the tailoring process.',
  },
];

export default function ServicesFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-[#C9A961] text-xs font-bold tracking-widest uppercase mb-3">Answers You Need</p>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Frequently Asked <span className="text-[#C9A961]">Questions</span>
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know before your first consultation
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-base font-semibold text-gray-900 pr-4 leading-snug">
                  {faq.q}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-gray-100">
                  <i className={`${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'} text-[#C9A961] text-lg`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed text-sm border-t border-gray-100 pt-4">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-500 mb-4">Still have questions?</p>
          <a
            href="tel:866-857-8487"
            className="inline-flex items-center bg-[#C9A961] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#B89851] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Call Us at 866-857-8487
          </a>
        </div>
      </div>
    </section>
  );
}
